import { render, staticRenderFns } from "./ordersPage.vue?vue&type=template&id=56e92856&"
import script from "./ordersPage.vue?vue&type=script&lang=js&"
export * from "./ordersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports